import {useEffect, useState} from 'react';
import * as React from 'react';
import {useCookies} from 'react-cookie';
import {Reservation} from '../ItemMasterRouter';
import ModalLauncher from '../shipper/ModalLauncher';
import ReservationDropdown from '../../shared/ReservationDropdown';
import {ItemMasterTable} from './ItemMasterTable';

export interface ItemMasterIndexProps {
  placeholder?: string;
  authenticityToken: string;
  isShipper: boolean;
  reservations?: Reservation[];
  showImsAlternateId: boolean;
  useReleaseDate: boolean;
  useSerialNumberProgram: boolean;
  imsBulkUpsertEnabled: boolean;
  imsEnableInnerPack: boolean;
  innerPackCsvEnabled: boolean;
}

const ItemMasterIndex: React.FC<ItemMasterIndexProps> = (props) => {
  const [reloadItemMaster, setReloadItemMaster] = useState(false);
  const [cookies] = useCookies(['selected_warehouse_id']);
  const [selectedReservationId, setSelectedReservationId] = useState<number>(-1);

  useEffect(() => {
    setReloadItemMaster(!reloadItemMaster);
  }, [selectedReservationId]);

  return (
    <div id="item-master-index">
      <div className="container-fluid detail-header">
        <div className="row">
          <div className="col-sm-12 action-buttons text-right">
            <div className="btn-group">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                className="btn dropdown-toggle"
                data-toggle="dropdown"
                type="button"
              >
                Download
                <i className="fa fa-download icon-padding-left"></i>
              </a>
              <ul className="dropdown-menu">
                <li key="all-res">
                  <a href="/s/inventories/export_inventory_quantities.csv">All reservations</a>
                </li>
                <li className="divider" role="separator"></li>
                <li className="dropdown-header">Specific Reservation</li>
                {props.reservations.map((res) => {
                  return (
                    <li key={res.id}>
                      <a href={`/s/inventories/export_inventory_quantities.csv?reservation_id=${res.id}`}>
                        #{res.id}: {res.warehouseName}, {res.warehouseCity}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <a className="btn aux-action" href="/s/inventories/new">
                <i className="fa fa-plus icon-padding-right"></i>
                SKU
              </a>
              <ModalLauncher
                authenticityToken={props.authenticityToken}
                showImsAlternateId={props.showImsAlternateId}
                useReleaseDate={props.useReleaseDate}
                useSerialNumberProgram={props.useSerialNumberProgram}
                imsBulkUpsertEnabled={props.imsBulkUpsertEnabled}
                imsEnableInnerPack={props.imsEnableInnerPack}
                innerPackCsvEnabled={props.innerPackCsvEnabled}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <h1>Item Master</h1>
        </div>
        <div className="row">
          {!props.isShipper ? (
            <ReservationDropdown
              warehouseId={cookies.selected_warehouse_id}
              selectedReservationIdChanged={setSelectedReservationId}
              includeAllOption={true}
            />
          ) : null}
        </div>
      </div>
      <div className="row">
        <ItemMasterTable
          authenticityToken={props.authenticityToken}
          isShipper={props.isShipper}
          reservationId={selectedReservationId}
        />
      </div>
    </div>
  );
};

export default ItemMasterIndex;
